import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    [
      !_vm.switches.length
        ? _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c(
                    VSwitch,
                    _vm._g(
                      _vm._b(
                        {
                          model: {
                            value: _vm.selected,
                            callback: function ($$v) {
                              _vm.selected = $$v
                            },
                            expression: "selected",
                          },
                        },
                        "VSwitch",
                        { ..._vm.$attrs },
                        false
                      ),
                      _vm.$listeners
                    )
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._l(_vm.switches, function (row, i) {
            return _c(
              VRow,
              { key: i },
              _vm._l(row, function (col) {
                return _c(
                  VCol,
                  { key: col[_vm.itemValue] },
                  [
                    _c(
                      VSwitch,
                      _vm._g(
                        _vm._b(
                          {
                            attrs: {
                              label:
                                typeof col === "object"
                                  ? col[_vm.itemText]
                                  : col,
                              value:
                                typeof col === "object"
                                  ? col[_vm.itemValue]
                                  : col,
                            },
                            model: {
                              value: _vm.selected,
                              callback: function ($$v) {
                                _vm.selected = $$v
                              },
                              expression: "selected",
                            },
                          },
                          "VSwitch",
                          { ..._vm.$attrs },
                          false
                        ),
                        _vm.$listeners
                      )
                    ),
                  ],
                  1
                )
              }),
              1
            )
          }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }